import {DataListModel} from '../interface';
import {ArticleModel} from './article.model';

export class ArticlesModel extends DataListModel {
  items: ArticleModel[] = [];
}
